export default class Folder {
	constructor({
		id,
		name,
		count,
		created,
		position,
	}) {
		this._id = id;
		this._name = name;
		this._count = count;
		this._created = created;
		this._position = position;
	}

	getId = () => this._id;

	getKey = () => String(this._id);

	getName = () => this._name;

	getCount = () => this._count;

	getCreated = () => this._created;

	getPosition = () => this._position;

	nextPosition = () => this.getPosition() + 1;

	prevPosition = () => this.getPosition() - 1;
}
